import initVueApp from "@/core.js";
const component = require(`./../views/Planet.vue`).default;
initVueApp(component);
